// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Page0_wrapper__24L4d","criminals":"Page0_criminals__1vBr6"};